import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const SUPPLIERS_REQUESTS = gql`
  query GetSuppliers {
    suppliers(limit: 1000, offset: 0) {
      data {
        codigo
        status
        dataCadastro 
        razaoSocial
        nomeFantasia
        cpfCnpj
        endereco
        numero
        cep
        bairro
        cidade
        estado
        pais
        telefone
        celular
        email
      }
      totalRecords
    }
  }
`;

export const getAllSuppliers = async () => {
    
        const response = await queryAllPages(client, {
            query: SUPPLIERS_REQUESTS,
            // variables: {
            //   input: bar
            // }
        });
        const { data } = response.data.suppliers;
        return data;
    
}
